(function () {
  'use strict';

  angular
    .module('maleFemaleDiscrepancy')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('maleFemaleDiscrepancy', {
        url: '/male-female-discrepancy',
        views: {
          'maleFemaleDiscrepancyView': {
            templateUrl: 'male-female-discrepancy/views/male-female-discrepancy.tpl.html',
            controller: 'MaleFemaleDiscrepancyCtrl',
            controllerAs: 'maleFemaleDiscrepancy'
          }
        }

      });
  }
}());
